import { ScreenSize } from './../../../styles/screen-sizes';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Options } from 'react-toast-notifications';
import { action } from 'typesafe-actions';

export const actionTypes = {
  SET_TOAST: 'Presentation/SetToast',
  SET_SHOW_MODAL: 'Presentation/SetShowModal',
  SET_SCREEN_SIZE: 'Presentation/SetScreenSize',
};

export const actions = {
  setToast: (content: string, options?: Options | undefined) =>
    action(actionTypes.SET_TOAST, { content, options }),
  setShowModal: (content?: JSX.Element, onClose?: () => void) =>
    action(actionTypes.SET_SHOW_MODAL, { content, onClose }),
  setScreenSize: (screenSize: ScreenSize) => action(actionTypes.SET_SCREEN_SIZE, screenSize),
};
